let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hOmwF")).then(() => parcelRequire('dhCNd'));